export { PersonalizedContractLink } from './personalized-contract-link.component';
